<div class="[ cluster cluster-space-2xs ]">
  <div class="flex-nowrap">
    @if (leadingIcon) {
      <campus-icon [svgIcon]="leadingIcon" class="[ icon-current ]"></campus-icon>
    }

    <span class="[ label-large truncate ]"><ng-content></ng-content></span>

    @if (trailingIcon) {
      <campus-icon [svgIcon]="trailingIcon" class="[ icon-current ]"></campus-icon>
    }
  </div>
</div>
<div class="[ state-layer ] [ primary index-pullback ] [ transition-opacity ]"></div>
<div
  class="[ absolute left-none top-none w-full h-full ] [ primary ] [ corner-inherit border-none index-pullback ] [ transition-all ]"
  style="clip-path: inset(0 calc(var(--progress, 0) * 1%) 0 0)"
  >
</div>

<dcr-state-layer class="bg-on-primary-container" [for]="element"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
